import { render, staticRenderFns } from "./ObkDescriptionNoAdBlockerStep.vue?vue&type=template&id=ec687c6e&scoped=true"
import script from "./ObkDescriptionNoAdBlockerStep.vue?vue&type=script&lang=js"
export * from "./ObkDescriptionNoAdBlockerStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec687c6e",
  null
  
)

export default component.exports